window._define('widgets/highlite', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) { 'use strict';

    var widgetName = 'highlite',
        jsClassName = 'js-highlite';

    // widget definition
    $.widget('OC.' + widgetName, BaseWidget, {
        options: {
            TTL: 5000,
        },

        _create: function () {
            this._super(jsClassName);
            this.element.css('position', 'relative');
            this.element.css('zIndex', 1);
            this.elements.$highlightElement = $('<span></span>').prependTo(this.element);
        },

        highlite: function () {
            var self = this;

            this.elements.$highlightElement.removeClass('is-dead');
            this.elements.$highlightElement.addClass('highlite');

            setTimeout(function () {
                self.elements.$highlightElement.addClass('is-dead');
            }, this.options.TTL);
        },
    });

    $('.' + jsClassName)[widgetName]();

    return $.OC[widgetName];
});
